import { render, staticRenderFns } from "./AdminLbGroupAssignPersonDialog.vue?vue&type=template&id=348f5dc9&scoped=true&"
import script from "./AdminLbGroupAssignPersonDialog.vue?vue&type=script&lang=js&"
export * from "./AdminLbGroupAssignPersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminLbGroupAssignPersonDialog.vue?vue&type=style&index=0&id=348f5dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f5dc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VForm,VIcon,VProgressLinear,VSelect,VTextField,VTooltip})
